import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { makeNetTerms } from '~/infra/translator';
import { AgreementChangeType } from './model';
export function makeNetTermsChange(netTerms) {
    return {
        type: AgreementChangeType.NetTerms,
        value: {
            netTerms: makeNetTerms(netTerms)
        }
    };
}
export function makeLegalTermsChange(legalTermsDocuments) {
    return {
        type: AgreementChangeType.legalTermsDocuments,
        value: {
            legalTermsDocuments: legalTermsDocuments.map((lt)=>{
                var _lt_contentOverride;
                return _object_spread({
                    legalTermsId: lt.legalTermsId
                }, lt.type === 'quill' ? {
                    contentOverride: (_lt_contentOverride = lt.contentOverride) !== null && _lt_contentOverride !== void 0 ? _lt_contentOverride : {
                        type: 'none'
                    }
                } : {});
            })
        }
    };
}
export function makeAmendmentsApprovalMethodChange(amendmentsApprovalMethod) {
    return {
        type: AgreementChangeType.AmendmentsApprovalMethod,
        value: {
            amendmentsApprovalMethod
        }
    };
}
export function makeInvoicesApprovalMethodChange(invoicesApprovalMethod) {
    return {
        type: AgreementChangeType.InvoicesApprovalMethod,
        value: {
            invoicesApprovalMethod
        }
    };
}
export function makeServicesChange(services) {
    return {
        type: AgreementChangeType.Services,
        value: {
            services
        }
    };
}
export function makeTitleChange(title) {
    return {
        type: AgreementChangeType.Title,
        value: {
            title
        }
    };
}
export function makeManualPaymentsChange(allowManualPayments) {
    return {
        type: AgreementChangeType.ManualPayments,
        value: {
            allowManualPayments
        }
    };
}
export function makeCoverCreditCardFeesChange(coverCreditCardFees) {
    return {
        type: AgreementChangeType.CoverCreditCardFees,
        value: {
            coverCreditCardFees
        }
    };
}
export function makeSellerChange(seller) {
    return {
        type: AgreementChangeType.Seller,
        value: {
            seller
        }
    };
}
export function makeServiceQboClassChange(serviceId, classBefore, classAfter) {
    return {
        type: AgreementChangeType.ServiceQboClass,
        value: {
            serviceId,
            integratedClass: {
                before: classBefore,
                after: classAfter
            }
        }
    };
}
